import { FC, useMemo, useState } from 'react';
import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { FormattedMessage } from 'react-intl';
import { ProviderField } from '../../models/provider';
import {
  ProviderInputs,
  SubmitProviderInputsPayload,
} from '../screens/SubmitCredentials/molecules/ProviderInputs/ProviderInputs';
import { ContentBody } from '../atoms/ContentBody/ContentBody';
import { Button } from '../atoms/Button/Button';
import { Footer } from '../atoms/Footer/Footer';
import { ChipTanFlicker } from '../screens/SubmitCredentials/molecules/ChipTan/ChipTanFlicker';
import { H1 } from '../atoms/Heading/Heading';
import { useCredentialsCopy } from '../screens/SubmitCredentials/hooks/useCredentialsCopy';
import { Text } from '../atoms/Text/Text';
import { TemplateElementStyle, TemplateElementType, Templates } from './templates';
import { messages } from './messages';
import { MaybeChangeMethodButton } from './MaybeChangeMethodButton/MaybeChangeMethodButton';

export type ChipTanTemplateViewProps = {
  fields: ProviderField[];
  onSubmit: (values: SubmitProviderInputsPayload) => void;
};

export const ChipTanTemplateView: FC<ChipTanTemplateViewProps> = ({ fields, onSubmit }) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);

  const parsedFields = useMemo(() => {
    const input = fields.find((el) => el.type === TemplateElementType.INPUT);
    const title = fields.find(
      (el) => el.type === TemplateElementType.TEXT && el.style === TemplateElementStyle.TITLE
    );
    const chiptan = fields.find(
      (el) => el.type === TemplateElementType.TEXT && el.style === TemplateElementStyle.INSTRUCTION
    );

    return { title, chiptan, inputs: input ? [input] : [] };
  }, [fields]);

  const { heading } = useCredentialsCopy();

  return (
    <ContentBody data-testid="chip-tan-template">
      <Box>
        <H1>{heading}</H1>

        {parsedFields.title?.value && (
          <Text mb="large" color="secondary">
            {parsedFields.title.value}
          </Text>
        )}

        {parsedFields.chiptan?.value && <ChipTanFlicker code={parsedFields.chiptan.value} />}

        <ProviderInputs
          formId={Templates.CHIP_TAN}
          providerFields={parsedFields.inputs}
          onSubmit={onSubmit}
          setButtonDisabled={(newState: boolean) => setIsButtonDisabled(newState)}
        />
      </Box>
      <Footer stickToBottom px="none">
        <Button
          form={Templates.CHIP_TAN}
          disabled={isButtonDisabled}
          type="submit"
          color="primary"
          variant="contained"
        >
          <FormattedMessage {...messages.idCompletionSubmitButton} />
        </Button>
        <MaybeChangeMethodButton elements={fields} onSubmit={onSubmit} />
      </Footer>
    </ContentBody>
  );
};
